export default __webpack_public_path__ + "static/media/roadmap.c3b05ca2.png";